import {
	GET_MAC_ACL,
	GET_MAC_ACL_SUCCESS,
	GET_MAC_ACL_FAIL,
	ADD_MAC_ACL,
	ADD_MAC_ACL_FAIL,
	ADD_MAC_ACL_SUCCESS,
} from '../../constants/globalProfileConstants/macAclConstants';

/**
 * Reducer function for managing mac acl list state.
 *
 * This reducer handles actions related to fetching mac acl data.
 * It updates the state based on the dispatched action type and payload.
 *
 * @param {object} state - Current state of the mac acl list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const macAclListReducer = (
	state = { macACl: {}, addMacAcl: false, addMac: {} },
	action
) => {
	switch (action.type) {
		case GET_MAC_ACL:
			return {
				loading: true,
			};
		case GET_MAC_ACL_SUCCESS:
			return {
				loading: false,
				macACl: action.payload,
			};
		case GET_MAC_ACL_FAIL:
			return {
				loading: false,
				error: action.payload,
			};
		case ADD_MAC_ACL:
			return {
				loading: false,
				addMacAcl: action.payload,
			};
		case ADD_MAC_ACL_SUCCESS: {
			return {
				...state,
				loading: false,
				addMac: action.payload,
                status: action.payload.status
			};
		}
		case ADD_MAC_ACL_FAIL: {
			return {
				...state,
				loading: false,
				addMac: 'error',
			};
		}
		default:
			return state;
	}
};
